module.exports = __webpack_public_path__ + "media/application/images/svgs/cloud-snow-0fc7f1bdf11809442a369eb96c5e4e73.svg";